export const namespace = 'pressSheets';

export const MutationTypes = {
  SET_PRESS_SHEET: 'SET_PRESS_SHEET',
  SET_PRESS_SHEETS: 'SET_PRESS_SHEETS',
  SET_PRESS_SHEET_HISTORY: 'SET_PRESS_SHEET_HISTORY',
};

export const ActionTypes = {
  GET_PRESS_SHEET: 'GET_PRESS_SHEET',
  GET_PRESS_SHEETS: 'GET_PRESS_SHEETS',
  GET_PRESS_SHEET_HISTORY: 'GET_PRESS_SHEET_HISTORY',
};
